import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Address } from "../../../../shared/ui/Address";
import { IContactUpdateResource } from "../../shared/types";
import {
	PrimaryLabel,
	ViewPageSection,
	ViewPageSectionBody,
	ViewPageSectionHeader,
	ViewPageSectionListItemWrapper,
} from "../../shared/view";

const StyledViewPageSection = styled(ViewPageSection)`
	grid-area: address;
`;

const StyledPrimaryLabel = styled(PrimaryLabel)`
	align-self: center;
`;

export const ArchivedContactViewAddressSection: FC<{ contact: IContactUpdateResource }> = ({ contact }) => {
	const { t } = useTranslation();
	return (
		<StyledViewPageSection>
			<ViewPageSectionHeader>{t("Addresses")}</ViewPageSectionHeader>
			<ViewPageSectionBody>
				{contact.addresses.map((address) => (
					<ViewPageSectionListItemWrapper key={address.id}>
						<Address address={address} />
						{address.isPrimary && <StyledPrimaryLabel />}
					</ViewPageSectionListItemWrapper>
				))}
			</ViewPageSectionBody>
		</StyledViewPageSection>
	);
};
